import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const VISUAL_ANALYSIS_SUPPORTED_INTEGRATIONS = [
  ExternalIntegrationEnum.Instagram,
  ExternalIntegrationEnum.Facebook,
]
